/* global promotionData */
import Vue from 'vue';

let promotionCollection = {};

new Vue({
	el: '.all-promotions-list',
	data: {
		isLoading: true,
		promotions: [],
		hasMore: false,
		query: {
			data: {
				page: 1,
				per_page: 8,
				order: 'desc',
				orderby: 'date',
				lang: promotionData['lang'],
				_fields:
					'title,excerpt,link,featured_image'
			}
		}
	},
	mounted() {
		this.doApiCall();
	},
	computed: {
		filteredPromotions() {
			return this.promotions;
		}
	},
	methods: {
		doApiCall() {
			wp.api.loadPromise
				.done(function() {
					// Initialize Promotion Collection
					promotionCollection = new wp.api.collections.Promotion();
				})
				.then(() => {
					this.apiQuery();
				});
		},
		apiQuery() {			this.isLoading = true;
			promotionCollection.fetch(this.query).done(this.parseData);
		},
		parseData(response) {
			this.hasMore = promotionCollection.hasMore();

			if (promotionCollection.state.currentPage > 1) {
				this.promotions = this.promotions.concat(response);
			} else {
				this.promotions = response;
			}
			this.isLoading = false;
		},
		loadMore() {
			promotionCollection.more().done(this.parseData);
		}
	}
});
